import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentCopyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_copy"}/>
}
